import React, { useState } from 'react';
import './CateringPage.css';
import WineMenuBook from '../pages/WineMenuBook'; 
import emailjs from '@emailjs/browser';
import { Typewriter } from 'react-simple-typewriter';




export default function CateringPage() {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    eventType: '',
    guestCount: '',
    date: '',
    notes: ''
  });

  const [submitted, setSubmitted] = useState(false);
  const [showGallery, setShowGallery] = useState(false);

  const handleChange = (e) => {
    setFormData(prev => ({
      ...prev,
      [e.target.name]: e.target.value
    }));
  };

        const handleSubmit = async (e) => {
            e.preventDefault();
        
            try {
            await emailjs.send('service_qjh8qj2', 'template_rxq83is', {
                from_name: formData.name,
                email: formData.email,
                message: `
                New Catering Request:
                Name: ${formData.name}
                Email: ${formData.email}
                Phone: ${formData.phone}
                Event: ${formData.eventType}
                Guests: ${formData.guestCount}
                Date: ${formData.date}
                Notes: ${formData.notes}
                `,
            }, 's_VbFAYhnBCg7dlCt');
        
            setSubmitted(true); 
            setFormData({
                name: '',
                email: '',
                phone: '',
                eventType: '',
                guestCount: '',
                date: '',
                notes: ''
            });
        
            setTimeout(() => setSubmitted(false), 4000);
            } catch (error) {
            console.error("Error submitting quote:", error);
            }
        };
  

  return (
    <>
      <div className="catering-bg">
        <div className="bg-slide slide1"></div>
        <div className="bg-slide slide2"></div>
        <div className="bg-slide slide3"></div>
      </div>

      <div className="catering-form-wrapper">
        <h1>The Main Ingredient | Catering</h1>

            <h3 className="catering-typewriter">
            <Typewriter
                words={[
                'Catering available for private jets...',
                'Small private gatherings or events...',
                'Please order 24–48 hours in advance.'
                ]}
                loop
                cursor
                typeSpeed={60}
                deleteSpeed={40}
                delaySpeed={1800}
            />
            </h3>



        <h2>Request a Quote</h2>
        {submitted && <p style={{ color: 'green' }}> Quote request submitted! We’ll be in touch soon.</p>}

        <form onSubmit={handleSubmit} style={{ maxWidth: '500px', display: 'flex', flexDirection: 'column', gap: '12px' }}>
          <input type="text" name="name" placeholder="Your name" value={formData.name} onChange={handleChange} required />
          <input type="email" name="email" placeholder="Your email" value={formData.email} onChange={handleChange} required />
          <input type="text" name="phone" placeholder="Phone number" value={formData.phone} onChange={handleChange} required />
          <input type="text" name="eventType"placeholder="Type of event (e.g., meeting, jet catering)" value={formData.eventType} onChange={handleChange} required/>
          <input type="number" name="guestCount" placeholder="Estimated number of guests" value={formData.guestCount} onChange={handleChange} />
          <input type="date" name="date" placeholder="Event date" value={formData.date} onChange={handleChange} />
          <textarea name="notes" placeholder="Additional notes or requests" rows="4" value={formData.notes} onChange={handleChange} />

          <button type="submit" style={{ padding: '10px', background: 'black', color: 'white', border: 'none', borderRadius: '5px' }}>
            Send Request
          </button>
        </form>

        <button onClick={() => setShowGallery(!showGallery)} className="gallery-toggle-button">
          {showGallery ? 'Hide Gallery' : 'View Catering Gallery'}
        </button>


        {showGallery && (
        <div className="catering-gallery">
            <img src="/gallery/food1.jpg" alt="food1" />
            <img src="/gallery/food2.jpg" alt="food2" />
            <img src="/gallery/food3.jpg" alt="food3" />
            <video src="/gallery/food4.mp4" controls muted />
            <video src="/gallery/food5.mp4" controls muted />
            <video src="/gallery/food6.mp4" controls muted />
            <video src="/gallery/food7.mp4" controls muted />
        </div>

        )}
      </div>

      <section className="section" style={{ marginTop: '60px' }}>
        <h2 style={{ textAlign: 'center', color: 'var(--accent)' }}>Specialty Wine Menu</h2>
        <WineMenuBook/>
        </section>
        
    </>
  );
}
